import { render, staticRenderFns } from "./returnEditPopup.vue?vue&type=template&id=2b1bd9dc"
import script from "./returnEditPopup.vue?vue&type=script&lang=js"
export * from "./returnEditPopup.vue?vue&type=script&lang=js"
import style0 from "./returnEditPopup.vue?vue&type=style&index=0&id=2b1bd9dc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports